const base = {
    host: 'https://pc.zdw000.com',
    api: '/api'
}
export default base